<template>
  <div class="main_div">
    <section id="container">

    </section>
  </div>
</template>

<script>
import ApiConfig from '@/api/api.config'
import EtnersCommonUtil from '@/common/etners.common.util'
import ApiUtil from '@/api/api.util'

export default {

  name: 'Main',
  components: {  },
  data () {
    return {
      platformDomain: ApiConfig.platformDomain
    }
  },
  mounted () {
    // 카테고리 리스트 바인드

  },
  created () {

  },
  methods: {

  }
}
</script>
<style>
.k-dropdown-wrap> .k-input {
  height: 100%
}
</style>
